import React, { useRef } from 'react';
import Table from "react-bootstrap/Table";
import { renderTableRow } from '../../config/utils';
import ActionItems from './showActions';
import moment from 'moment';
import { Tooltip as WmsTooltip } from "react-tooltip";
import { accountTransactionType } from '../../constant';
import PropTypes from 'prop-types';
import { BsPencil, BsSave2 } from "react-icons/bs";

const EditableCell = ({
    isEditing,
    value,
    inputType,
    onChange,
    onKeyDown,
    onSave,
    onStartEdit,
    item,
    columnKey,
    }) => {
    if (isEditing) {
        return (
        <div className="inline-edit displayFlexAndBetween">
            <input
                type={inputType || 'text'}
                value={value}
                onChange={onChange}
                onKeyDown={(e) => onKeyDown(e, item)}
                className="cus-input-cls thresh-data"
                autoFocus
            />

            <button
                className="iconBtnListing ml-2 mr-2"
                onClick={() => onSave(item)}
                id={`save-${item.id}`}
                >
                <BsSave2
                    className="penconEditIcon saveIconCarrier"
                    title="Save"
                ></BsSave2>
            </button>
            <WmsTooltip anchorId={`save-${item.id}`} content="Save" place="left" />
        </div>
        );
    }

    return (
        <button
            className="editable-cell cursorPointer sortBtn inline-edit"
            onClick={() => onStartEdit(item, columnKey)}
        >
        {item[columnKey]}
        <BsPencil
            id={`edit-${item.id}`}
            className="cus-pencil-icon-sec View-Icon editThreshold ml-5"
            title="Edit"
        />
        <WmsTooltip
            anchorId={`edit-${item.id}`}
            content="Edit Count"
            place="left"
        />
        </button>
    );
};

EditableCell.propTypes = {
    isEditing: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    inputType: PropTypes.string,
    onChange: PropTypes.func,
    onKeyDown: PropTypes.func,
    onSave: PropTypes.func,
    onStartEdit: PropTypes.func,
    item: PropTypes.any,
    columnKey: PropTypes.string,
};

const DataTable = (props) => {
    const {
        loader,
        headers,
        tableData,
        tableDataStatus,
        filterData,
        handleSortingColumn,
        actionType,
        handleAction,
        handleUploadDialog,
        handleCheckRecord,
        name = '',
        isSelectAll = false,
        handleLinkAction
    } = props;
    const hoverTimerRef = useRef(null);

    const handleStatusClass = (item) => {
        return item.Status === "Error" ? "activeStatus errorStatus uploads" : "activeStatus uploads"
    }

    const renderActionContent = (actionType, item) => {
        switch (actionType) {
            case 2:
                return (
                    <>
                        <ActionItems type={'View'} item={item} handleAction={() => handleAction(item, 'view', false)} />
                        <ActionItems type={'Edit'} item={item} handleAction={() => handleAction(item, 'edit', false)} />
                        <ActionItems type={'History'} item={item} handleAction={() => handleAction(item, 'history', false)} />
                    </>
                );
            case 3:
                return (
                    <>
                        <ActionItems type={'View'} item={item} handleAction={() => handleAction(item, 'view')} />
                        <ActionItems type={'Edit'} item={item} handleAction={() => handleAction(item, 'edit')} />
                    </>
                );
            case 4:
                return (
                    <i className="fa fa-refresh link" aria-hidden="true" onClick={handleUploadDialog}></i>
                );
            case 5:
                return (
                    <>
                        <button onClick={() => handleAction(item, 'print', false)} className="iconBtnListing mr-15 cursorPointer" id={`print-${item.id}`}>
                            <i className="fa fa-print" aria-hidden="true"></i>
                        </button>
                        <WmsTooltip
                            anchorId={`print-${item.id}`}
                            content={'Print'}
                            place="left"
                            className="tooltipWidth"
                        />
                        <ActionItems type={'View'} icon="view" item={item} handleAction={() => handleAction(item, 'view', false)} />
                    </>
                );
            case 6:
                return (
                    <ActionItems type={'icon'} iconType="fa fa-check-square-o" item={item} handleAction={() => handleAction(item, 'singleUpdate')} />
                );
            case 7:
                return (
                    <ActionItems type={'icon'} iconType="fa fa-print" item={item} handleAction={() => handleAction(item, 'print', false)} />
                );
            case 8:
                return (
                    <>
                        <button onClick={() => handleAction(item, 'approve')} className="iconBtnListing mr-15 cursorPointer" id={`approve-${item.Id}`}>
                            <i className="fa fa-check-square-o" aria-hidden="true"></i>
                        </button>
                        <button onClick={() => handleAction(item, 'delete')} className="iconBtnListing mr-15 cursorPointer" id={`reject-${item.Id}`}>
                            <i className="fa fa-times error-icon" aria-hidden="true"></i>
                        </button>
                        <button onClick={() => handleAction(item, 'viewRequest')} className="iconBtnListing mr-15 cursorPointer" id={`view-${item.Id}`}>
                            <i className="fa fa-eye" aria-hidden="true"></i>
                        </button>
                        <WmsTooltip
                            anchorId={`approve-${item.Id}`}
                            content={'Approve'}
                            place="left"
                            className="tooltipWidth"
                        />
                        <WmsTooltip
                            anchorId={`reject-${item.Id}`}
                            content={'Reject'}
                            place="left"
                            className="tooltipWidth"
                        />
                        <WmsTooltip
                            anchorId={`view-${item.Id}`}
                            content={'View Request'}
                            place="left"
                            className="tooltipWidth"
                        />
                    </>
                );
            case 9:
                return (
                    <ActionItems type={'History'} item={item} handleAction={() => handleAction(item, 'history', false)} />
                );
            case 10:
                return (
                    <>
                        {item.referenceId && item.transactionTypeId === accountTransactionType.TRANSACTION_PAYMENT && (
                            <ActionItems
                                type={"icon"}
                                item={item}
                                handleAction={() =>handleAction(item, 'makeEntry')}
                                iconContent="Add Entry"
                                iconType="fa fa-plus-circle"
                            />
                        )}
                        <ActionItems type={'View'} item={item} handleAction={() => handleAction(item, 'view')} />
                        <ActionItems type={'Edit'} item={item} handleAction={() => handleAction(item, 'edit')} />
                    </>
                );
            case 11:
                return (
                    <>
                        <button onClick={() => handleAction(item, 'approve')} className="iconBtnListing mr-15 cursorPointer" id={`approve-${item.id}`}>
                            <i className="fa fa-check-square-o" aria-hidden="true"></i>
                        </button>
                        <WmsTooltip
                            anchorId={`approve-${item.id}`}
                            content={'Approve'}
                            place="left"
                            className="tooltipWidth"
                        />
                        <ActionItems type={'View'} item={item} handleAction={() => handleAction(item, 'view')} />
                        <ActionItems type={'Edit'} item={item} handleAction={() => handleAction(item, 'edit')} />
                    </>
                );
            case 12:
                return (
                    <>
                        <button onClick={() => handleAction(item, 'approve')} className="iconBtnListing mr-15 cursorPointer" id={`approve-${item.id}`}>
                            <i className="fa fa-check-square-o" aria-hidden="true"></i>
                        </button>
                        <WmsTooltip
                            anchorId={`approve-${item.id}`}
                            content={'Approve'}
                            place="left"
                            className="tooltipWidth"
                        />
                    </>
                );
            default:
                return null;
        }
    };

    const [editingCell, setEditingCell] = React.useState(null);

    const startEdit = (item, columnKey) => {
        setEditingCell({
            rowId: item.listIndex,
            columnKey,
            value: item[columnKey],
        });
    };

    const cancelEdit = () => {
        setEditingCell(null);
    };

    const saveEdit = (item) => {
        handleAction(item, 'inlineUpdate', editingCell); // send to parent
        setEditingCell(null);
    };

    const handleKeyDown = (e, item) => {
        if (['.', 'e', '-'].includes(e.key)) {
            e.preventDefault();
            return;
        }

        if (e.key === 'Enter') saveEdit(item);
        if (e.key === 'Escape') cancelEdit();
    };

    const handleEditingCellChange = (e) => {
        setEditingCell({
            ...editingCell,
            value: e.target.value.replace(/\D/g, ''), //NOSONAR
        });
    };

    const renderkey2Content = (col, item) => {
        return (
            <div>
                {col === 'receivedDate' ?  moment(item['receivedDate']).format(
                    "MM-DD-YYYY | h:mm:ss A"
                ) : (
                    <button onClick={() => handleAction(item, 'edit')} className="seller-modal sortBtn ml-0" title="Click to navigate back to Packages">{item[col]}</button>
                )}
            </div>
        )
    };

    const handleMouseEnter = (item) => {
        hoverTimerRef.current = setTimeout(() => {
            handleAction(item, 'thumbnail')();
        }, 1000); // 1 second
    };

    const handleMouseLeave = () => {
        if (hoverTimerRef.current) {
            clearTimeout(hoverTimerRef.current);
            hoverTimerRef.current = null;
        }
    };


    return (
        <div className='incomingTbl'>
            <Table
                className={`tableWide table-height cus-left-right-col-layout ${loader ? "disableTble" : ""}`}
            >
                <thead className="tbl-btch">
                    <tr className="table-rw-batch">
                        {headers.map((item, index) => (
                            <th key={item.key} width={item?.width} className={item?.customClass}>
                                {item.isSorting ? (
                                    <button
                                        className={
                                            filterData?.sortColumn === item.key
                                                ? "active sortBtn"
                                                : "sortColumn sortBtn"
                                        }
                                        onClick={() => handleSortingColumn(item.key)}
                                    >
                                        {item.label}
                                        <i
                                            className={
                                                filterData?.sortColumn === item.key &&
                                                    filterData?.sortOrder === "ASCENDING"
                                                    ? "fa fa-arrow-up"
                                                    : "fa fa-arrow-down"
                                            }
                                            aria-hidden="true"
                                        ></i>
                                    </button>
                                ) : (
                                    <>{item.key === 'isChecked' ? <input checked={isSelectAll} type='checkbox' disabled={!tableData.length} name="selectAll" onChange={(e) => handleCheckRecord(e, {}, name)} /> : <>{item.label}</>}</>
                                )}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody className="tbl-bt-body">
                    {tableData?.map((item) => (
                        <tr key={item.listIndex}>
                            {headers.map((column) => {
                                let cellContent;
                                if (column.key === "Status") {
                                    cellContent = (
                                        <>
                                            <div
                                                className={handleStatusClass(item)}
                                            >
                                                {item?.Status}
                                            </div>
                                            {item?.Status === "Downloaded" ? (
                                                <a
                                                    rel="noreferrer"
                                                    href={item.DownloadCsvURL}
                                                >
                                                    <i
                                                        className="fa fa-cloud-download fa-lg"
                                                        aria-hidden="true"
                                                    ></i>
                                                </a>
                                            ) : null}
                                        </>
                                    );
                                } else if (column.isDate) {
                                    cellContent = <>
                                        {moment(item[column.key]).format(
                                            "MM-DD-YYYY | h:mm:ss A"
                                        )}</>;
                                } else if (column.key === 'isChecked') {
                                    cellContent = <><input type='checkbox' checked={item.isChecked} name="selectRecord" onChange={(e) => handleCheckRecord(e, item, name)} /></>;
                                } else if (column.key === 'payStatus') {
                                    cellContent = <>{item[column.key]} {item[column.key] === 'Un-Paid' && <button onClick={() => props.showPayNow(true)} className='payBtn cus-primary-transparent-btn btn'>Pay Now</button>}</>;
                                } else if (column.htmlElement) {
                                    cellContent = <span dangerouslySetInnerHTML={{ __html: item[column.key] }}></span>;
                                } else if (column.type === 'orderDetails') {
                                    cellContent = <>
                                        <div className='flexDataTableList'>
                                            <div>{item[column.key]}</div>
                                            <div className='detailBox'>
                                                <div>Single Qty - {item.singleQtyOrderCount}</div>
                                                <div>Single SKU Multiple Qty - {item.singleSKUMultipleQtyOrderCount}</div>
                                                <div>Multi SKU - {item.multiSKUOrderCount}</div>
                                            </div>
                                        </div>
                                    </>;
                                } else if (column?.isClickable) {
                                    cellContent = 
                                        <button
                                            className="clickable-cell sortBtn normalTxt linkBtn"
                                            onClick={handleLinkAction(item, column.key)}
                                        >
                                            {item[column.key]}
                                        </button>;
                                } else if (column.isEditable) {
                                    const isEditing =
                                        editingCell?.rowId === item.listIndex &&
                                        editingCell?.columnKey === column.key;

                                    cellContent = (
                                        <EditableCell
                                            isEditing={isEditing}
                                            value={editingCell?.value}
                                            inputType={column.inputType}
                                            onChange={handleEditingCellChange}
                                            onKeyDown={handleKeyDown}
                                            onSave={saveEdit}
                                            onStartEdit={startEdit}
                                            item={item}
                                            columnKey={column.key}
                                        />
                                    );
                                } else if (column.isMultipleLine) {
                                    cellContent = <div className='multipleLineData alignCenter'>
                                        <button 
                                            className='sortBtn thumbImg ml-0' 
                                            onClick={() => handleAction(item, 'thumbnail')()}
                                            onMouseEnter={() => handleMouseEnter(item)}
                                            onMouseLeave={handleMouseLeave}
                                        >
                                            {item[column.key1] && (
                                                <img src={item[column.key1]} alt='icon' />
                                            )}
                                        </button>
                                        {renderkey2Content(column.key2, item)}
                                        {column.showApproveReject && (
                                            <div className='hoverContent'>
                                                <button className='inlineApprove cus-primary-bg-btn btn' onClick={() => handleAction(item, 'approve')}>Approve</button>
                                            </div>
                                        )}
                                    </div>;
                                } else if (column.key) {
                                    cellContent = <>{item[column.key]}</>;
                                } else {
                                    cellContent = renderActionContent(actionType, item)
                                }

                                return <td key={column.id} className={column.customClass}>{cellContent}</td>;
                            })}
                        </tr>
                    ))}
                    {tableDataStatus === "SUCCESS" &&
                        tableData.length === 0 && (
                            <>{renderTableRow(headers.length, "No Result Found...")}</>
                        )}
                </tbody>
            </Table>
        </div>
    );
}

DataTable.propTypes = {
    loader: PropTypes.bool,
    headers: PropTypes.array,
    tableData: PropTypes.array,
    tableDataStatus: PropTypes.any,
    filterData: PropTypes.object,
    handleSortingColumn: PropTypes.func,
    actionType: PropTypes.any,
    handleAction: PropTypes.func,
    handleUploadDialog: PropTypes.func,
    handleCheckRecord: PropTypes.func,
    name: PropTypes.string,
    isSelectAll: PropTypes.bool,
    showPayNow: PropTypes.func,
    handleLinkAction: PropTypes.func,
}

export default DataTable;
